import { KEY_REDUCER_SW } from "@/shared/store/sw/constants";

export const selectorDownloadProgresses = (state) => state[KEY_REDUCER_SW].downloadProgresses;